export const adRejectReasonsData = [
  {text: ' Missing Witnesses’ or Notary’s Signature. '},
  {text: 'Missing Principal signature.'},
  {text: 'Principal and witnesses’ / notary’s signature dates do not match.'},
  {text: 'Missing date on form.'},
  {text: 'Directive form missing pages.'},
  {text: 'Form has different patient information.'},
  {text: 'Not a valid Advance Directive document.'},
  {text: 'Form is not legible.'},
  {text: 'Patient refused to sign.'},
  {text: 'Invalid signatures.'}
];
